import { post, get, put, putData, postData } from "../base.ehq.model";
import {
  serialize,
  serializeChangePassword,
  serializeProfile
} from "./user.serializer";
import { deserialize } from "../base.serializer";
import { ResponsePayload } from "@/types/model";

export const verifyUser = async (
  token: string,
  baseUrl: string,
  body: unknown
) => {
  try {
    const queryPath = `${baseUrl}/users/verify_user`;

    const serializedBody = serialize(body);
    const res = await post(token, queryPath, serializedBody);
    return deserialize(res);
  } catch (err) {
    throw new Error(err);
  }
};

export const getUser = async (
  token: string,
  baseUrl: string,
  id: string,
  config: object
) => {
  try {
    const queryPath = `${baseUrl}/users/${id}`;

    const res = await get(token, queryPath, {}, config);
    return deserialize(res);
  } catch (err) {
    throw new Error(err);
  }
};

export const changePassword = async (
  token: string,
  baseUrl: string,
  body: unknown
) => {
  const queryPath = `${baseUrl}/users/change_password`;

  const serializedBody = serializeChangePassword(body);
  return await putData(token, queryPath, serializedBody).then(
    (res: ResponsePayload) => deserialize(res.data)
  );
};

export const changeProfile = async (
  token: string,
  baseUrl: string,
  userId: string,
  body: unknown
) => {
  try {
    const queryPath = `${baseUrl}/users/${userId}`;

    const serializeBody = serializeProfile(body);
    const res = await put(token, queryPath, serializeBody);
    return deserialize(res);
  } catch (err) {
    throw new Error(err);
  }
};

export const logOutUser = (token: string, baseUrl: string) => {
  const queryPath = `${baseUrl}/users/logout`;

  return postData(token, queryPath).then((response: ResponsePayload) =>
    deserialize(response.data)
  );
};
